module.exports = __webpack_public_path__ + "static/media/timer_control_base.33daa232.svg";